import type { CareerServicesDashboardWindow } from "../queries";

export const DEFAULT_DASHBOARD_WINDOW: CareerServicesDashboardWindow = "LAST_7_DAYS";

export const DASHBOARD_TIMEFRAME_OPTIONS = [
  { label: "7D", value: "LAST_7_DAYS" },
  { label: "14D", value: "LAST_14_DAYS" },
  { label: "30D", value: "LAST_30_DAYS" },
  { label: "60D", value: "LAST_60_DAYS" },
  { label: "6M", value: "LAST_6_MONTHS" },
  { label: "12M", value: "LAST_12_MONTHS" }
] satisfies { label: string; value: CareerServicesDashboardWindow }[];

const DASHBOARD_WINDOW_LABELS: Record<CareerServicesDashboardWindow, string> = {
  LAST_7_DAYS: "last 7 days",
  LAST_14_DAYS: "last 14 days",
  LAST_30_DAYS: "last 30 days",
  LAST_60_DAYS: "last 60 days",
  LAST_6_MONTHS: "last 6 months",
  LAST_12_MONTHS: "last 12 months"
};

export function isCareerServicesDashboardWindow(value: string | null): value is CareerServicesDashboardWindow {
  return DASHBOARD_TIMEFRAME_OPTIONS.some((option) => option.value === value);
}

export function dashboardWindowLabel(window: CareerServicesDashboardWindow): string {
  return DASHBOARD_WINDOW_LABELS[window];
}
